/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_TitleInputs */

const en_us2_search_title = /** @type {(inputs: Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const pt_br2_search_title = /** @type {(inputs: Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const es_419_search_title = /** @type {(inputs: Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const pt_pt2_search_title = /** @type {(inputs: Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const fr_fr2_search_title = /** @type {(inputs: Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const de_de2_search_title = /** @type {(inputs: Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche`)
};

const it_it2_search_title = /** @type {(inputs: Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Search_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_title = /** @type {((inputs?: Search_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_title(inputs)
	if (locale === "es-419") return es_419_search_title(inputs)
	if (locale === "pt-PT") return pt_pt2_search_title(inputs)
	if (locale === "fr-FR") return fr_fr2_search_title(inputs)
	if (locale === "de-DE") return de_de2_search_title(inputs)
	if (locale === "it-IT") return it_it2_search_title(inputs)
	return en_us2_search_title(inputs)
});
export { search_title as "search.title" }